import { initSwitchableItems, CollabsibleContainer } from "@plugins";
import { elementScrollIntoView } from "seamless-scroll-polyfill";

const sidebarAdvantagesContainer = document.querySelector(".js-sidebar-advantages-container");

window.addEventListener(
    "load",
    initSwitchableItems(".js-sidebar-advantages", ".js-sidebar-advantages-item"),
    initScrollingElements(),
);

if (sidebarAdvantagesContainer) {
    new CollabsibleContainer(sidebarAdvantagesContainer, {
        buttonClasses: "link-more link-more--big js-sidebar-advantages-item-more collapsed",
        collapsibleItemsClass: "js-sidebar-advantages-item",
        limiter: 13,
    });
}

function initScrollingElements() {
    if (sidebarAdvantagesContainer) {
        const sidebarAdvantagesItems = sidebarAdvantagesContainer.querySelectorAll(
            ".js-sidebar-advantages-item",
        );

        if (sidebarAdvantagesItems) {
            sidebarAdvantagesItems.forEach((item) => {
                item.addEventListener("click", () => {
                    const glossaryItems = document.querySelectorAll(".js-glossary-item");

                    if (glossaryItems) {
                        glossaryItems.forEach((glossaryItem) => {
                            if (glossaryItem.dataset.id === item.id) {
                                elementScrollIntoView(glossaryItem, {
                                    behavior: "smooth",
                                    block: "start",
                                });
                            }
                        });
                    }
                });
            });
        }
    }
}
